module.exports = __webpack_public_path__ + "images/158_160.jpg";